import { AsyncPipe, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { SessionIdleMonitorService } from 'core/services';
import { BehaviorSubject } from 'rxjs';
import { finalize } from 'rxjs/operators';

@Component({
    standalone: true,
    selector: 'dc-session-idle-warning-dialog',
    templateUrl: './session-idle-warning-dialog.component.html',
    styleUrls: ['./session-idle-warning-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AsyncPipe, NgIf, MatButtonModule, MatDialogModule, TranslatePipe],
})
export class SessionIdleWarningDialogComponent implements OnDestroy {
    public readonly state$ = this.sessionIdleMonitorService.state$;
    public readonly isPinging$ = new BehaviorSubject<boolean>(false);

    constructor(private sessionIdleMonitorService: SessionIdleMonitorService) {}

    public ngOnDestroy(): void {
        this.isPinging$.complete();
    }

    public stayInSystem(): void {
        if (this.isPinging$.value) {
            return;
        }

        this.isPinging$.next(true);
        this.sessionIdleMonitorService
            .ping()
            .pipe(finalize(() => this.isPinging$.next(false)))
            .subscribe({ error: () => undefined });
    }
}
